// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rwd-video{height:0;overflow:hidden;padding-bottom:56.25%;padding-top:30px;position:relative}.rwd-video embed,.rwd-video iframe,.rwd-video object{height:100%;left:0;position:absolute;top:0;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
